import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';
import { TopUpStackRoutes, TopUpStackScreenProps } from './type';
import { TopUpWebOneScreen } from './TopUpWebOne.screen';
import { TopUpNativeOneScreen } from './TopUpNativeOne.screen';

export const TopUpConfirm: React.FC<TopUpStackScreenProps<TopUpStackRoutes.Confirm>> = ({ navigation, route }) => {
  const { onLayout, data, func, onReturnData, refresh, record } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <TopUpNativeOneScreen
        onClose={onGoBack}
        onLayout={onLayout}
        data={data}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
        record={record}
      />
    );
  }

  return (
    <TopUpWebOneScreen
      onClose={closeModal}
      onLayout={onLayout}
      data={data}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
      record={record}
    />
  );
};
